import { render, staticRenderFns } from "./GiftProduct.vue?vue&type=template&id=ce8a2846"
import script from "./GiftProduct.vue?vue&type=script&lang=js"
export * from "./GiftProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports